<template>
<v-layout row justify-center class="billingModule">
  <v-flex md3 class="sidebar">
    <aside>
      <span class="patient_profile">
        <h4>{{ptName}}</h4>
        <h5>{{ptAge}}/{{ptGender}} <span v-if='ptPlace !== "undefined"'>, {{ptPlace}}</span> </h5>
    </span>
      <ul>
        <li>
          <router-link :to="{ name: 'vitalsPost', params: {appId: `${appId}`,ptId: `${ptId}`}}">Vitals</router-link>
        </li>
        <li>
          <router-link :to="{ name: 'prescription', params: {appId: `${appId}`,ptId: `${ptId}`} }">Prescriptions</router-link>
        </li>
        <li class="active">
          <router-link :to="{ name: 'billing', params: {appId: `${appId}`,ptId: `${ptId}`}}">Billing</router-link>
        </li>
      </ul>
    </aside>
  </v-flex md3>
  <v-flex md9 pl-3 pr-3>
    <v-layout row wrap>
      <v-flex md3 mt-4 pr-2 v-for='(item, index) in billList'>
      <v-card  color="blue-grey darken-2" class="white--text">
        <v-card-title>
           <div>
             Bill No: {{index+1}}
           </div>
        </v-card-title>
        <v-card-actions>
          Amount Paid: </br>
          {{item.paid}}
        </v-card-actions>
      </v-card>
      </v-flex>
      <v-flex md3 mt-4 class="addWrapper">
      <span class="add">
        <router-link :to="{ name: 'billing', params: {appId: `${appId}`,ptId: `${ptId}`} }">
          <span>+ Add</span>
        </router-link>
      </span>
      <!-- <v-card color="blue-grey darken-2" class="white--text">
        <v-card-title>
             <v-dialog v-model="dialog" max-width="800px">
               <v-btn color="primary" dark slot="activator">Add new bills</v-btn>
               <v-flex xs12>
                 <h1>{{item.amount}}</h1>
                </v-flex>
             </v-dialog>
        </v-card-title>
      </v-card> -->
      </v-flex>
  </v-layout>


    <!-- <table>
      <tbody>
        <tr v-for='(item, index) in billList'>
          <td>
            {{item.amount}}
          </td>
        </tr>
      </tbody>
    </table> -->
  </v-flex>
</v-layout>
</template>

<script>
import Vue from 'vue'
import {
  api
} from '../api.js';
import {
  mapState
} from 'vuex';
import {
  axios,
  get,
  post
} from 'axios';
import _ from 'lodash';
export default {
  name: 'allBills',
  data() {
    return {
      billList: '',
      dialog: false,

    }
  },
  computed: {
    appId: function() {
      if (this.$route.params.appId !== null) {
        return this.$route.params.appId
      }
    },
    ptId: function() {
      if (this.$route.params.ptId !== null) {
        return this.$route.params.ptId
      }
    },ptName: function() {
        return localStorage.getItem("ptName")
      },
      ptAge: function() {
        if(localStorage.getItem("ptAge")==="null"){
          return ''
        }
        return localStorage.getItem("ptAge")
      },
      ptGender: function() {
        return localStorage.getItem("ptGender")
      },
      ptPlace: function() {
        if(localStorage.getItem("ptPlace")==="null"){
          return ''
        }
        return localStorage.getItem("ptPlace")
      }
  },
  mounted() {
      this.getBills()
  },
  methods: {
    getBills(){
      get(api + `/billings?person_id=${this.ptId}&is_today=true`)
        .then(res => {
          console.log(res);
          this.billList = res.data.bill_list
        })
    }
  }
}
</script>

<style lang="css" scoped>
.el-input {
  width: 10px;
  margin: auto;
}
.addWrapper {
  text-align: center;
    display: flex;
    justify-content: center;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    align-items: center;
}
.add {
  /* padding: 3rem 0; */
}
.billingModule {
  min-height: 99vh;
}

#example-1 {
  font-size: 20px;
  padding: 20px;
  margin-left: 1.5rem;
}

#example-2 {
  /*padding: 20px;*/
}

#detail {
  border: 1px solid #d8d8d8;
  border-radius: 4px;
  margin: 10px;
  padding: 8px;
  /* width: 30%; */
  margin-left: 2rem;
}

#charge {
  border: 1px solid #d8d8d8;
  /* border-radius: 4px; */
  padding: 8px;
  /* width: 15%; */
  /* margin: 10px; */
}

#qty {
  border: 1px solid #d8d8d8;
  border-radius: 4px;
  margin: 10px;
  padding: 8px;
  /* width: 10%; */
}

.listOfCharges {
  display: flex;
}

#partiallyPaid {
  border: 1px solid #d8d8d8;
  border-radius: 4px;
  padding: 8px;
  width: 15%;
}

/* .card__title {
  background-color: #018FFF;
  color: white;
  font-size: 80px;
} */

ul {
  list-style: none;
}

.fa-times-circle-o {
  color: #8080808a;
}

.invoiceTotals {
  padding: 20px;
  margin-left: 1.5rem;
  text-align: right;
  padding-right: 5rem;
}

.invoiceTotals>h3 {
  margin: 10px 0px;
}

.sidebar {
  background-color: #383B3F;
  color: #fff;
}

.sidebar ul li {
  padding: 1rem;
}

.sidebar ul li a {
  color: white;
  text-decoration: none;
}

.sidebar .active {
  background-color: #F2994A;
}

.patient_profile>h4 {
  padding: 10px 10px 2px 10px;
}

.patient_profile>h5 {
  padding: 0 10px 10px;
}

.fa-inr {
  margin-left: 1rem;
  margin-right: 0.5rem;
}

.card__actions {
  justify-content: flex-start;
  padding: 16px;
}

.autocompleteSelect {
  width: 65%;
}
</style>



// WEBPACK FOOTER //
// src/components/allBills.vue